import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "formatMobile",
    standalone: false
})
export class FormatMobilePipe implements PipeTransform {
	transform(value: string): string {
		return value.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3");
	}
}
